import { render, staticRenderFns } from "./SubPage.vue?vue&type=template&id=4952e694&scoped=true&"
import script from "./SubPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubPage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SubPage.vue?vue&type=style&index=0&id=4952e694&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952e694",
  null
  
)

export default component.exports